import {
    ProductType,
} from 'app/enums/label.enums'

const plannedUpdateMapContainerTypes: {
    productType: ProductType,
    imgSrc: string,
}[] = [
    {
        productType: ProductType.VAL_1500XCOL,
        imgSrc: 'assets/images/containerTypes/tp_1500X.png',
    },
    {
        productType: ProductType.VAL_1500XCRT,
        imgSrc: 'assets/images/containerTypes/tp_1500X.png',
    },
    {
        productType: ProductType.VAL_1500F,
        imgSrc: 'assets/images/containerTypes/tp_1500F.png',
    },
    {
        productType: ProductType.VAL_2500C,
        imgSrc: 'assets/images/containerTypes/tp_2500C.png',
    },
    {
        productType: ProductType.VAL_2500CRT,
        imgSrc: 'assets/images/containerTypes/tp_2500CRT.png',
    },
    {
        productType: ProductType.VAL_1500C,
        imgSrc: 'assets/images/containerTypes/tp_1500C.png',
    },
    {
        productType: ProductType.VAL_1500CRT,
        imgSrc: 'assets/images/containerTypes/tp_1500CRT.png',
    },
    {
        productType: ProductType.VAL_1500DF,
        imgSrc: 'assets/images/containerTypes/tp_1500DF.png',
    },
    {
        productType: ProductType.VAL_1500DF_EUROMAX,
        imgSrc: 'assets/images/containerTypes/tp_1500DF.png',
    },
    {
        productType: ProductType.VAL_770C,
        imgSrc: 'assets/images/containerTypes/tp_770C.png',
    },
    {
        productType: ProductType.VAL_ONEC,
        imgSrc: 'assets/images/containerTypes/tp_ONEC.png',
    },
    {
        productType: ProductType.VAL_ONECRT,
        imgSrc: 'assets/images/containerTypes/tp_ONECRT.png',
    },
]

export default plannedUpdateMapContainerTypes
